module.exports = __webpack_public_path__ + "img/sdk-3-0.e3a4c66.svg";